// The seller session token from the OTP login (uniquegiftapi
// includes/sellerSession.js). Plan checkout and invoices (/api/plan/*) act for
// the logged-in seller only, so axiosInstance sends it as X-Seller-Token next to
// the app's client token. Cleared with the rest of localStorage on logout
// (NavigationBar).

export const SELLER_TOKEN_KEY = "seller_token";
export const SELLER_TOKEN_HEADER = "X-Seller-Token";
// The API's 401 when the seller token is missing, expired or invalid
export const SELLER_SESSION_REQUIRED = "seller_session_required";

export const getSellerToken = () => {
    try { return window.localStorage.getItem(SELLER_TOKEN_KEY); } catch (e) { return null; }
};

export const saveSellerToken = (token) => {
    if (!token) return;
    try { window.localStorage.setItem(SELLER_TOKEN_KEY, token); } catch (e) { /* storage blocked */ }
};

// Log in again (e.g. logged in before seller tokens existed, or the 7-day token
// expired). A plan being bought goes along, so checkout reopens after login.
export const loginAgainPath = (location = window.location) => {
    const params = new URLSearchParams(location.search);
    const plan = location.pathname === "/purchase-plan" ? params.get("plan") : null;
    return plan ? `/login?plan=${encodeURIComponent(plan)}` : "/login";
};

export const endSellerSession = () => {
    const next = loginAgainPath();
    try {
        ["seller_token", "user_id", "business_id", "signup", "email_address", "phone_number"]
            .forEach(key => window.localStorage.removeItem(key));
    } catch (e) { /* storage blocked */ }
    window.location.assign(next);
};

